import { render } from "./SupportControls.vue?vue&type=template&id=545a04c3&scoped=true"
import script from "./SupportControls.vue?vue&type=script&lang=js"
export * from "./SupportControls.vue?vue&type=script&lang=js"

import "./SupportControls.vue?vue&type=style&index=0&id=545a04c3&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/wdw-vue build and deploy Teledata PROD/wdw-vue-widgets/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-545a04c3"]])

export default __exports__